import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';

import { get } from 'lodash';
import * as fp from 'lodash/fp';

import {
  rx,
  Observable,
  observableThrowError,
  ErrorObservable,
} from '@shared/rx';
import * as config from '@config/index';
import { environment } from '../../../../environments/environment';
import { EHeaderName } from '@shared/types/enums';

/**
 * XprtSessionService provides API for Xprt backend sign-in.
 */
@Injectable()
export class XprtSessionService {
  public config: any = config;

  public static parseToken(token: string): any {
    return {
      token,
      user: JSON.parse(atob(token.split('.')[1])),
    };
  }

  private get baseUrl(): string {
    return environment.xprtBackendURI;
  }

  public constructor(private http: HttpClient) {}

  public fetchPersonalToken(payload: any): Observable<{ token: string }> {
    const body = { user: payload.user, password: payload.password };

    return this.http
      .post(`${this.baseUrl}/token`, body, { responseType: 'text' })
      .pipe(
        rx.catchError<string, any>(
          this.makeHttpErrorHandler((err) =>
            Error.call(err, get(err, ['meta', 'message'])),
          ),
        ),
        rx.map((token: string) => ({ token })),
      );
  }

  public fetchAccessToken(companyId: string): Observable<{ token: string }> {
    const headers = new HttpHeaders({
      [EHeaderName.Authorization]: config.PERSONAL_TOKEN,
    });

    return this.http
      .post(
        `${this.baseUrl}/me/access-token`,
        { company_id: companyId },
        { headers, responseType: 'text' },
      )
      .pipe(
        rx.catchError<string, any>(
          this.makeHttpErrorHandler((err) => new Error(err as any)),
        ),
        rx.map((token: string) => ({ token })),
      );
  }

  private makeHttpErrorHandler = (
    riser: (err: object) => Error,
  ): ((err: HttpErrorResponse) => ErrorObservable<Error[]>) =>
    fp.flow(fp.get('error.errors'), fp.map(riser), observableThrowError);
}
